import React from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';

/**
 * withRouter HOC for React Router v6
 * Provides history-like API for class components that previously used props.history
 */
export function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();

    // Create a history-like object for backward compatibility
    const history = {
      push: (path, state) => {
        if (typeof path === 'string') {
          navigate(path, { state });
        } else if (typeof path === 'object') {
          navigate(path.pathname + (path.search || ''), { state: path.state });
        }
      },
      replace: (path, state) => {
        if (typeof path === 'string') {
          navigate(path, { replace: true, state });
        } else if (typeof path === 'object') {
          navigate(path.pathname + (path.search || ''), { replace: true, state: path.state });
        }
      },
      go: (n) => navigate(n),
      goBack: () => navigate(-1),
      goForward: () => navigate(1),
      location,
    };

    return (
      <Component
        {...props}
        history={history}
        location={location}
        params={params}
        navigate={navigate}
      />
    );
  }

  return ComponentWithRouterProp;
}

export default withRouter;
